import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import featurePropTypes from '../types/feature';
import {
  performanceMark, // eslint-disable-line no-unused-vars
  performanceMeasure, // eslint-disable-line no-unused-vars
  performanceClearMarks, // eslint-disable-line no-unused-vars
  performanceClearMeasures // eslint-disable-line no-unused-vars
} from '../util/performance';
import { getDisplayName } from '../util/react';

export default (
  WrappedComponent,
  options = {
    performanceMark, // eslint-disable-line no-use-before-define
    performanceMeasure, // eslint-disable-line no-use-before-define
    performanceClearMarks, // eslint-disable-line no-use-before-define
    performanceClearMeasures // eslint-disable-line no-use-before-define
  }
) => {
  const {
    performanceMark,
    performanceMeasure,
    performanceClearMarks,
    performanceClearMeasures
  } = options;
  const displayName = getDisplayName(WrappedComponent);
  const marks = [];
  const measures = [];
  let count = 0;

  return class PerformanceContainer extends PureComponent {
    static displayName = `PerformanceContainer(${displayName})`;

    static propTypes = {
      frontEndPerformanceMonitoringEnabled: featurePropTypes,
      location: PropTypes.shape({
        pathname: PropTypes.string
      })
    };

    componentWillMount() {
      if (this.props.frontEndPerformanceMonitoringEnabled) {
        performanceMark('Mount-start');
        marks.push('Mount-start');
      }
    }

    componentDidMount() {
      const {
        frontEndPerformanceMonitoringEnabled,
        location: { pathname } = {}
      } = this.props;

      if (frontEndPerformanceMonitoringEnabled) {
        performanceMark('Mount-end');
        marks.push('Mount-end');
        performanceMeasure(
          `action=Mount&component=${displayName}&pathname=${pathname}`,
          'Mount-start',
          'Mount-end'
        );
        measures.push(
          `action=Mount&component=${displayName}&pathname=${pathname}`
        );
      }
    }

    componentWillUpdate() {
      if (this.props.frontEndPerformanceMonitoringEnabled) {
        count++;
        performanceMark(`Update-start-${count}`);
        marks.push(`Update-start-${count}`);
      }
    }

    componentDidUpdate() {
      const {
        frontEndPerformanceMonitoringEnabled,
        location: { pathname } = {}
      } = this.props;

      if (frontEndPerformanceMonitoringEnabled) {
        performanceMark(`Update-end-${count}`);
        marks.push(`Update-end-${count}`);
        performanceMeasure(
          `action=Update&component=${displayName}&pathname=${pathname}&id=${count}`,
          `Update-start-${count}`,
          `Update-end-${count}`
        );
        measures.push(
          `action=Update&component=${displayName}&pathname=${pathname}&id=${count}`
        );
      }
    }

    componentWillUnmount() {
      if (this.props.frontEndPerformanceMonitoringEnabled) {
        marks.forEach(mark => performanceClearMarks(mark));
        measures.forEach(measure => performanceClearMeasures(measure));
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};



// WEBPACK FOOTER //
// ./js/performanceContainer/performanceContainer.js